"use client";


import CWFResponsiveDialog from "@/components/ui/CWFResponsiveDialog";
import {Tabs, TabsContent, TabsList, TabsTrigger} from "@/components/ui/tabs";
import LoginForm from "@/components/site/LoginForm";
import RegisterForm from "@/components/site/RegisterForm";
import {Button} from "@/components/ui/button";
import React, {useEffect, useState} from "react";
import {getSession, useSession} from "next-auth/react";
import {authOptions} from "@/lib/authOptions";
import useAvatarStore from "@/lib/store/avatarStore";

export default function AuthAction({ action, trigger, placeholder,sign = false, ...props }) {

    const session = useSession();
    const [open, setOpen] = useState(sign);
    const [processOngoing, setProcessOngoing] = useState(false);
    const {updateUrl} = useAvatarStore();
    useEffect(() => {
        if (!open && processOngoing) {
            setProcessOngoing(false);
        }
    }, [open, processOngoing]);

    function handleClick() {
        if (session.status === "authenticated") {

            action?.();
        } else {
            setOpen(true);
            setProcessOngoing(true);
        }
    }

    function onSignedIn() {
        setOpen(false);

        getSession(authOptions).then(session =>{
            if(session.user.user.docs.length > 0){
                updateUrl(session.user.user.docs[0].path);
            }
        }).catch(err => console.error(err));
        action?.();
    }

    return (
        <>
            {placeholder && !processOngoing && session.status === "authenticated" ? (
                placeholder
            ) : (
                <>
                    {trigger ? (
                        React.cloneElement(trigger, { onClick: handleClick })
                    ) : <Button onClick={handleClick}>Connexion</Button>}

                    <CWFResponsiveDialog
                        open={open}
                        onOpenChange={setOpen}
                        title={<p>Compte CWF-Coworkfit gratuit</p>}
                        description={"Authentifiez-vous ou rejoignez-nous pour continuer"}
                        trigger={null}
                        {...props}
                    >
                        <Tabs defaultValue={sign ? "signup" : "signin"} className="grid gap-4">
                            <TabsList className="grid w-full grid-cols-2">
                                <TabsTrigger value="signin">Connexion</TabsTrigger>
                                <TabsTrigger value="signup">Inscription</TabsTrigger>
                            </TabsList>
                            <TabsContent value="signin">
                                <LoginForm onSuccess={onSignedIn} />
                            </TabsContent>
                            <TabsContent value="signup">
                                <RegisterForm onSuccess={onSignedIn} />
                            </TabsContent>
                        </Tabs>
                    </CWFResponsiveDialog>
                </>
            )}
        </>

    );
}
